import { type ReactNode } from "react";

import { ConfigContext } from "~/contexts/config";
import { type Config } from "~/contexts/config";

interface ConfigProviderProps {
  children: ReactNode;
  config: Config;
}

export function ConfigProvider({ children, config }: ConfigProviderProps) {
  return (
    <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
  );
}
